import React, { FC } from "react";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import styles from "./FerdigManuell.module.less";

const FerdigManuell: FC = (): React.ReactElement => {
  return (
    <main className={styles.doneContainer}>
      <img
        src={"/images/illustration/postkasse-ipad.svg"}
        alt={""}
        className={styles.illustration}
      />
      <Heading level={1} size={"large"}>
        <Translated textKey={"done_manual.header"} />
      </Heading>
      <p>
        <Translated textKey={"done_manual.body"} />
      </p>
    </main>
  );
};

export default FerdigManuell;
